<template>
  <v-container class="fill-height">
    <v-row class="justify-center align-center">
      <v-progress-circular
        color="primary"
        :size="100"
        :width="15"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    url: "",
    title: "",
    parent: "",
    child: "",
  }),
  async mounted() {
    if (!this.isEmpty(this.$route.query)) {
      const { p, c } = this.$route.query;
      this.parent = p;
      this.child = c;
      if (this.isEmpty(this.parent)) {
        this.url = "/404";
      } else {
        const el = await this.$store.dispatch("findOneById", this.parent);
        this.title = el.TITLE;
        if (!this.isEmpty(this.parent)) {
          this.url = "/dikr/" + this.kebabCase(this.title);
          if (!this.isEmpty(this.child)) {
            this.url += "#doa2-" + this.child;
          }
        } else {
          this.url = "/";
        }
      }
    } else {
      this.url = "/";
    }
    this.$router.push(this.url);
  },
  metaInfo() {
    return { title: this.title };
  },
};
</script>
